<div *ngIf="isLoading; else content" class="flex flex-col">
  <span class="!w-104 shimmer !h-24"></span>
  <span class="!w-200 shimmer mt-8 !h-24"></span>

  <span *ngFor="let shimmer of shimmersIterable" class="shimmer mt-24 !h-40"></span>
</div>

<ng-template #content>
  <h1>{{ 'INVITE_NEIGHBORS_REGISTER.WELCOME' | translate }}</h1>
  <p class="text-md font-semi-bold mb-0 mt-8 leading-normal">
    {{ 'INVITE_NEIGHBORS_REGISTER.SIGN_UP_TO_ACCESS' | translate }}
  </p>

  <form class="mt-24" [formGroup]="form">
    <div class="group">
      <label for="sign-up-form--input--name">
        {{ 'INVITE_NEIGHBORS_REGISTER.NAME' | translate }}
      </label>
      <input
        tsqTextInput
        formControlName="name"
        id="sign-up-form--input--name"
        schema="new-primary"
        class="control font-base"
        type="text"
      />
    </div>

    <div class="group mt-24">
      <label for="sign-up-form--input--last-name">
        {{ 'INVITE_NEIGHBORS_REGISTER.LAST_NAME' | translate }}
      </label>
      <input
        tsqTextInput
        formControlName="lastName"
        id="sign-up-form--input--last-name"
        schema="new-primary"
        class="control font-base"
        type="text"
      />
    </div>

    <div class="group mt-24">
      <label for="sign-up-form--input--email">
        {{ 'INVITE_NEIGHBORS_REGISTER.EMAIL' | translate }}
      </label>
      <input
        tsqTextInput
        formControlName="email"
        id="sign-up-form--input--email"
        schema="new-primary"
        class="control font-base"
        type="email"
      />
    </div>

    <div class="group mt-24">
      <label tsqOptionalLabel>{{ 'INVITE_NEIGHBORS_REGISTER.UNIT' | translate }}</label>
      <tsq-typeahead
        formControlName="unit"
        schema="new-primary"
        [dataSource]="propertiesTypeaheadService"
        [props]="properties"
        [selectedTemplate]="selectedTemplate"
      />
    </div>

    <div class="group mt-24">
      <label tsqOptionalLabel>{{ 'INVITE_NEIGHBORS_REGISTER.PHONE_NUMBER' | translate }}</label>
      <comm-intl-phone-input
        formControlName="phone"
        schema="new-primary"
        [preferredCountryCodes]="['BR', 'US', 'CA', 'MX']"
        [defaultSelectedCountryCode]="defaultSelectedCountryCode"
      />
    </div>

    <tsq-button
      *ngIf="!isSigningUp; else loader"
      class="mt-24"
      schema="new-primary"
      size="lg"
      type="submit"
      [text]="'INVITE_NEIGHBORS_REGISTER.SIGN_UP' | translate"
      [disabled]="form.invalid"
      (clicked)="submitForm()"
    />
    <ng-template #loader>
      <div class="mt-24 flex h-40 items-center justify-center">
        <tsq-small-loader />
      </div>
    </ng-template>

    <tsq-button
      class="mt-16"
      schema="new-primary"
      kind="tertiary"
      size="lg"
      route="/login"
      [text]="'INVITE_NEIGHBORS_REGISTER.BACK_TO_LOGIN' | translate"
      [disabled]="isSigningUp"
    />
  </form>
</ng-template>

<ng-template #selectedTemplate let-item="item">
  <span>{{ item.text }}</span>
</ng-template>
